import React from 'react';
import { array, func, object } from 'prop-types';
import { contains } from 'ramda';

import { ConversationDetailsContext } from '../../context';
import { CONVERSATION_ERROR, GET_ALL_CONVERSATIONS } from '../../constants/ActionTypes';
import Layout from '../Layout';
import Header from '../Header';
import SessionMessage from '../SessionMessage';
import ErrorMessage from '../ErrorMessage';
import Footer from '../Footer';

// Page styles
import s from './Menu.css';
import ConversationList from '../ConversationList';

const Menu = ({ error, loadingState, conversationList, sessionTime, switchConversation }) => {

    // Tests will fail if we do not give this Ramda method what it expects, an array. this.props.loadingState.requests returns an array.
    const isLoadingAllConversations = contains(GET_ALL_CONVERSATIONS, loadingState.requests || []);
    const errorMessageExists = error && error.data && error.data.error;

    return (
        <Layout column fullscreen className={s.component}>
            <ConversationDetailsContext.Consumer>
                {conversationDetails => (
                    <Header
                        practiceName={conversationDetails ? conversationDetails.practiceName : 'Unknown'}
                    />)}
            </ConversationDetailsContext.Consumer>

            {error && error.type === CONVERSATION_ERROR &&
                <ConversationDetailsContext.Consumer>
                    {conversationDetails => (
                        <ErrorMessage
                            title="Sorry, an error occurred trying to load the conversations."
                            message={errorMessageExists ? error.data.error : `If this persists, please contact ${conversationDetails.practiceName}.`}
                        />
                    )}
                </ConversationDetailsContext.Consumer>
            }

            {conversationList &&
                <ConversationList
                    isLoadingAllConversations={isLoadingAllConversations}
                    conversationList={conversationList}
                    switchConversation={switchConversation}
                />
            }

            <SessionMessage
                sessionTime={sessionTime}
            />

            <section className={s.footerContainer}>
                <Footer dark />
            </section>
        </Layout>
    );
};

Menu.propTypes = {
    error: object,
    loadingState: object,
    conversationList: array,
    sessionTime: object,
    switchConversation: func.isRequired,
};

export default Menu;